import { useEffect } from 'react'
import { Terminal } from '@stripe/terminal-js'

const dangerousAbsorbErrorSilently = () => {
  // absorb this error if there's nothing to do about it
  // typically: if we try cancelling a payment knowing it may fail as it was not processing any more
}

// Confirm on exit and cancel any collection in progress then disconnect
export const useCleanExitOnWindowClose = (terminal?: Terminal) => {
  useEffect(() => {
    const confirmCancel = (e: Event) => {
      e.preventDefault()
    }
    const cancelCollect = async () => {
      await terminal
        ?.cancelCollectPaymentMethod()
        .catch(dangerousAbsorbErrorSilently)
        .finally(() =>
          terminal.disconnectReader().catch(dangerousAbsorbErrorSilently)
        )
    }
    window.addEventListener('beforeunload', confirmCancel)
    window.addEventListener('unload', cancelCollect)

    return () => {
      window.removeEventListener('beforeunload', confirmCancel)
      window.removeEventListener('unload', cancelCollect)
    }
  }, [terminal])
}

// On unmount, cancel any collection in progress then disconnect
export const useCleanExitOnUnmount = (terminal?: Terminal) => {
  useEffect(() => {
    return () => {
      terminal
        ?.cancelCollectPaymentMethod()
        .catch(dangerousAbsorbErrorSilently)
        .finally(() =>
          terminal.disconnectReader().catch(dangerousAbsorbErrorSilently)
        )
    }
  }, [terminal])
}
